import React, { useMemo } from 'react';
import { BaseNav } from './base-nav.component';
import { useNav } from '../../nav.context';
import { permissionChecks } from '../primary-navbar.helper';

export const FilesNav = () => {
  const nav = useNav();

  const navLinks = useMemo(() => {
    const hasTranscriptsPermissions = permissionChecks.canCreateTranscript(nav.user);
    const hasContactFilesPermissions = permissionChecks.canAccessContactFiles(nav.user);
    const hasInternalFilesPermissions = permissionChecks.canAccessInternalFiles(nav.user);
    return [
      { label: 'Contact Files', url: 'files/contacts/root', enabled: hasContactFilesPermissions },
      { label: 'Internal Files', url: 'files/internal/root', enabled: hasInternalFilesPermissions },
      { label: 'My Files', url: `files/personal/USR${nav.user.id}`, enabled: true },
      { label: 'Recently Viewed', url: 'files/recent/root', enabled: true },
      { label: 'Transcripts', url: 'transcripts/list', enabled: hasTranscriptsPermissions },
    ];
  }, [nav.user]);

  return (
    <BaseNav
      title="Files"
      nav={nav}
      navLinks={navLinks}
    />
  );
};
